import React, { useState } from "react";
import { PlusIcon, MinusIcon } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
interface FaqItemProps {
  question: string;
  answer: string;
}
export function FaqItem({
  question,
  answer
}: FaqItemProps) {
  const [open, setOpen] = useState(false);
  return <div className="border border-neutral-800 rounded-xl bg-neutral-950 overflow-hidden" data-id="element-23" data-mp="1r035na3fvtmd">
      <button onClick={() => setOpen(o => !o)} aria-expanded={open} className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-24" data-mp="1d0k81b8980ob">
        <span className="font-condensed text-xl text-white tracking-wide" data-id="element-25" data-mp="1h405uaw2872l">{question}</span>
        <span className="flex-shrink-0 text-[#e10600]" data-id="element-26" data-mp="134gxbgzc6tpr">
          {open ? <MinusIcon className="w-6 h-6" data-id="element-27" data-mp="1817c80zenj9l" /> : <PlusIcon className="w-6 h-6" data-id="element-28" data-mp="182inelv6jtaq" />}
        </span>
      </button>
      <AnimatePresence initial={false} data-id="element-29" data-mp="2xhynlbr4m4oh">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} data-id="element-30" data-mp="2xf43jlc0ylvl">
            <p className="px-5 pb-5 text-neutral-400 leading-relaxed" data-id="element-31" data-mp="v42xb3j5g1f0">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}